import { Injectable, OnInit } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LocalStorageService } from './connectors/localstorage';

@Injectable({
  providedIn: 'root'
})
export class MobileLoginGuard implements CanActivate {
  deviceInfo: any;

  constructor(
    private localstorage: LocalStorageService,
    private route: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const logged = this.localstorage.get('NTTUSLOGIN');
    if (!logged) {
      this.route.navigate(['/']);
    }

    return true;
  }
}
